import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styled from '@emotion/styled';

interface SecondaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  icon?: ReactNode;
}

const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 14px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: #fff;
  color: #262626;
  font-family: inherit;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;

  &:hover:not(:disabled) {
    border-color: #14395e;
    color: #14395e;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const IconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  line-height: 1;
`;

export const SecondaryButton = ({
  children,
  icon,
  type = 'button',
  ...rest
}: SecondaryButtonProps) => (
  <StyledButton type={type} {...rest}>
    {icon ? <IconSlot>{icon}</IconSlot> : null}
    {children}
  </StyledButton>
);
